import { Text, Drawer, useDisclosure, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, Flex, Avatar, Button } from '@chakra-ui/react'
import { useQuery } from '../../convex/_generated/react'
import React from 'react'

import { ModalProps } from './Modal.types'
import { Resource } from '../../types'
import { Id } from '../../convex/_generated/dataModel'
import ResourcesFormModal from './ResourceFormModal'
import { FiPlus } from 'react-icons/fi'
interface IProps extends ModalProps {
  onSelect?: (resource: Resource, id: Id) => void
}

const ResourcesPicker: React.FC<IProps> = ({ isOpen = false, size = 'md', onClose, onSelect }) => {
  const list = useQuery('listResources') || []

  const { isOpen: isNewResOpen, onOpen, onClose: onNewResClose } = useDisclosure()

  return (
    <>
      <Drawer
        size={size}
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            <Text fontSize="3xl">Pick resource</Text>
          </DrawerHeader>

          <DrawerBody>
            { list.map(res => (
              <Flex cursor="pointer" p={3} borderRadius={6} _hover={{ backgroundColor: 'whiteAlpha.100' }} gap={4} onClick={() => onSelect && onSelect(res, res._id)} key={res._id?.toString()}>
                <Avatar name={res.name} />
                <Flex direction={'column'}>
                  <Text fontSize={'1xl'}>{ res.name }</Text>
                  <Text fontSize={'small'}>{ res.designation }</Text>
                </Flex>
              </Flex>
            )) }
            <Button onClick={onOpen} gap={4}><FiPlus /> New Resource</Button>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <ResourcesFormModal
        isOpen={isNewResOpen}
        onClose={onNewResClose}
      />
    </>
  )
}

export default ResourcesPicker
